export default {
  container: {
    marginRight: '10px',
    padding: '15px 0px',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '600',
    marginTop: '0',
    marginLeft: '2px'
  },
  panel: {
    backgroundColor: 'white',
    padding: '15px',
    border: 'solid .05px rgba(0, 0, 0, .065)',
    boxSizing: 'border-box',
    boxShadow: 'inset 0 0 2px #d3d3d3',
    marginBottom: '15px'
  },
  button: {
    marginRight: '10px',
    fontWeight: '700'
  }
}
